export const switchStyles = {
  components: {
    Switch: {
      variants: {
        brand: {
          bg: "red.500",
          _hover: {
            bg: "brand.600",
          },
          _active: {
            bg: "brand.700",
          },
          // _focus: "none",
        },
      },
    },
  },
};
